import i18next from 'i18next';

import { ErrorImageType } from '@egr/xbox/egr-gui-dialogs/errorDialog/ErrorDialog';
import { FatalErrorWithCustomMessage } from '../Errors';

export class SessionExpiredError extends FatalErrorWithCustomMessage {
    public constructor(error: Error) {
        super(
            error,
            i18next.t('Session expired'),
            undefined,
            i18next.t('Your session has expired. The project must be closed.'),
            true,
            {
                errorImageType: ErrorImageType.SESSION_TIMEOUT
            }
        );

        Object.setPrototypeOf(this, SessionExpiredError.prototype);
    }
}